import React, { Component } from 'react';

class EnlisteeSearchResultsMessage extends Component {
  render() {
    if (this.props?.pagination?.pages > 1) {
      return (
        <p>There are a lot of results for this search, so we can't show them all. Please try refining you search term to narrow down your results.</p>
      )
    }
    return null;
  }
}

export default EnlisteeSearchResultsMessage;
